import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectWebskin } from 'reducers/auth';

import { selectClientLogo } from 'reducers/virtualAssessments';
import { getJobBoardClientNameFromLocalStorage } from 'helpers/jobBoardClientNameLocalStorage/getJobBoardClientNameFromLocalStorage';

import ClevryLogo from 'assets/apply.clevry/Logo2.png';
import SantanderLogo from 'assets/apply.clevry/santander-logo.png';
import { selectAccessibilityData } from 'reducers/accessibility';
import { useIsMoj } from './useIsMoj';

export const useLogo = (): string => {
  const selectedWebskin = useSelector(selectWebskin);
  const { isSet: isAccessibleTheme, isLight } = useSelector(
    selectAccessibilityData
  );
  const clientLogo = useSelector(selectClientLogo);

  const isMoj = useIsMoj();

  return useMemo(() => {
    const logoOverride = getLogoOverride();

    if (logoOverride) {
      return logoOverride;
    }

    if (clientLogo && !isMoj) {
      return clientLogo;
    } else if (selectedWebskin && selectedWebskin.siteImages) {
      const defaultLogo = selectedWebskin.siteImages.find(
        (item: any) => item.code === 'SI_Logo'
      )?.imageDownloadURI;
      const darkModeLogo = selectedWebskin.siteImages.find(
        (item: any) => item.code === 'SI_Dark_Logo'
      )?.imageDownloadURI;
      return isAccessibleTheme && !isLight
        ? darkModeLogo ?? defaultLogo
        : defaultLogo;
    } else {
      return ClevryLogo;
    }
  }, [selectedWebskin, clientLogo, isAccessibleTheme, isLight, isMoj]);
};

const getLogoOverride = () => {
  const currentClient = getJobBoardClientNameFromLocalStorage();

  switch (currentClient) {
    case 'santandercib':
    case 'staging-santandercib':
      return SantanderLogo;
    default:
      return null;
  }
};
